export const SESSION_ID_COOKIE_NAME = "session-id";

//For Contact us page
export const MAIL_TO = "mailto:";

